import { CartContent } from "@/components/cart-content"

export default function CartPage() {
    return <CartContent />
}
